import ReactDOM from 'react-dom';
import { useState } from 'react';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import Calendar from './Calendar';

loadDOMComponent({
	selector: 'react-calendar',
	callback: ({ container }) => {
		// const id = container.getAttribute('data-target-hidden-id');

		ReactDOM.render(
			<AppContextProvider>
				<Calendar />
			</AppContextProvider>,
			container,
		);
	},
});
